export default __webpack_public_path__ + "static/media/woman.8e3ac7b3.png";